import { EditButton } from "../../../components/Buttons/index.js";
import { FilesListDisplay } from "../../Files/shared/FilesListDisplay.js";
import { useMemo } from "react";
import { Card } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Locations/shared/ContactCard.tsx
var ContactCard = ({ contact, onEdit }) => {
	const { contactInfo, note, title } = contact;
	const infoByType = useMemo(() => {
		if (Array.isArray(contactInfo)) {
			const groups = {};
			contactInfo.forEach(({ type, value }) => {
				groups[type] ||= [];
				groups[type].push(value);
			}, {});
			const sortedGroups = [];
			if (groups["phone"]) sortedGroups.push({
				type: "phone",
				values: groups["phone"]
			});
			if (groups["email"]) sortedGroups.push({
				type: "email",
				values: groups["email"]
			});
			Object.keys(groups).forEach((type) => {
				if (type !== "email" && type !== "phone") sortedGroups.push({
					type,
					values: groups[type]
				});
			});
			return sortedGroups;
		}
		return [];
	}, [contactInfo]);
	return /* @__PURE__ */ jsxs(Card, {
		space: "0",
		children: [
			/* @__PURE__ */ jsxs("div", { children: [
				/* @__PURE__ */ jsxs("div", {
					className: "inline-flex w-full items-center justify-between",
					children: [/* @__PURE__ */ jsx("h4", {
						className: "text-lg",
						children: title
					}), onEdit && /* @__PURE__ */ jsx(EditButton, { onClick: onEdit })]
				}),
				!!note && /* @__PURE__ */ jsx("p", {
					className: "mt-xxs text-color-subtle whitespace-pre-wrap",
					children: note
				}),
				/* @__PURE__ */ jsx("div", { className: "mt-xs border-border border-t" })
			] }),
			/* @__PURE__ */ jsx("div", {
				className: "mt-sm gap-lg xxl:grid-cols-4 grid auto-cols-fr grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
				children: infoByType.map(({ type, values }) => /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
					className: "text-color-subtle font-medium capitalize",
					children: type
				}), /* @__PURE__ */ jsx("ul", {
					className: "leading-relaxed",
					children: values.map((entry) => /* @__PURE__ */ jsx("li", { children: entry }, entry))
				})] }, type))
			}),
			/* @__PURE__ */ jsx("div", {
				className: "mt-xl",
				children: /* @__PURE__ */ jsx(FilesListDisplay, { fileUrls: contact.fileUrls })
			})
		]
	});
};
//#endregion
export { ContactCard };

//# sourceMappingURL=ContactCard.js.map